import Title from "antd/es/typography/Title";
import React from "react";

interface AccountPageTitleProps {
    title: string
}

const AccountPageTitle = (
    {
        title
    }: AccountPageTitleProps
) => {
    return (
        <div style={{textAlign: 'center', marginBottom: 24}}>
            <img
                src="/logo.png"
                alt="Логотип"
                width={80}
                height={80}
                style={{objectFit: 'contain', marginBottom: 8}}
            />
            <Title level={2}>{title}</Title>
        </div>
    );
};

export default AccountPageTitle;